import type { CSSProperties, FormEvent } from "react";

import { RATING_OPTIONS, YEAR_MAX, YEAR_MIN } from "../../game/filters";
import { Chip } from "../components/common";
import { useController, useGame } from "../context";

const fill = (value: number): CSSProperties =>
  ({ "--fill": `${((value - YEAR_MIN) / (YEAR_MAX - YEAR_MIN)) * 100}%` }) as CSSProperties;

export function FiltersScreen() {
  const controller = useController();
  const catalog = useGame((s) => s.catalog);
  const form = useGame((s) => s.filterForm);
  const busy = useGame((s) => s.busy);

  const submit = (event: FormEvent) => {
    event.preventDefault();
    void controller.submitFilters();
  };

  return (
    <section className="screen">
      <form className="filters-form" onSubmit={submit}>
        <div className="filter-block">
          <h4>Страны</h4>
          <div className="chips">
            {catalog?.countries.map((name) => (
              <Chip
                key={name}
                active={form.countries.includes(name)}
                onClick={() => controller.toggleCountry(name)}
              >
                {name}
              </Chip>
            ))}
          </div>
        </div>

        <div className="filter-block">
          <h4>Жанры</h4>
          <div className="chips">
            {catalog?.genres.map((name) => (
              <Chip
                key={name}
                active={form.genres.includes(name)}
                onClick={() => controller.toggleGenre(name)}
              >
                {name}
              </Chip>
            ))}
          </div>
        </div>

        <div className="filter-block">
          <h4>Год выпуска</h4>
          <div className="years-label">
            <span data-testid="year-from">{form.yearFrom}</span> —{" "}
            <span data-testid="year-to">{form.yearTo}</span>
          </div>
          <input
            className="range"
            type="range"
            aria-label="Год выпуска от"
            min={YEAR_MIN}
            max={YEAR_MAX}
            value={form.yearFrom}
            style={fill(form.yearFrom)}
            onChange={(e) => controller.setYear("from", Number(e.target.value))}
          />
          <input
            className="range"
            type="range"
            aria-label="Год выпуска до"
            min={YEAR_MIN}
            max={YEAR_MAX}
            value={form.yearTo}
            style={fill(form.yearTo)}
            onChange={(e) => controller.setYear("to", Number(e.target.value))}
          />
        </div>

        <div className="filter-block">
          <h4>Рейтинг от</h4>
          <div className="chips">
            {RATING_OPTIONS.map((value) => (
              <Chip
                key={value}
                active={form.ratingFrom === value}
                onClick={() => controller.setRating(value)}
              >
                {value}+
              </Chip>
            ))}
          </div>
        </div>

        <button type="submit" className="btn" disabled={busy}>
          Готово
        </button>
      </form>
    </section>
  );
}
